export default Boolean(typeof window !== 'undefined' && window.document)
